var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('slick-carousel');
require('sweetalert');
require('./sliders2');
require('./click');
require('./contact');
require('./quotation');
require('jquery-modal');
//require('./question');
//require('./quotation_pymes');


$(".titleac").click(function(){
    $(".itemac").removeClass("active");
    $(this).parent().addClass("active");
    $(".iconac").text("+");
    $(this).children(".iconac").text("-");
});


// banner mobile

const enlaces = document.getElementsByClassName("enlaces")[0];
const hamburguesa = document.getElementById("hamb");
const menuHamburguesa = document.getElementById("menum");
const phoneMenu = document.getElementById('phoneMenu')
const openCallMenu = document.getElementById('openCallMenu')
const openCallMenuDesk = document.getElementById('openCallMenuDesk')
const closeCallMenu = document.getElementById('closeCallMenu')

if (openCallMenu || openCallMenuDesk){
    openCallMenu.addEventListener('click', ()=>{
        phoneMenu.classList.toggle('phoneMenuShow')
    })
    openCallMenuDesk.addEventListener('click', ()=>{
        phoneMenu.classList.toggle('phoneMenuShow')
    })
    closeCallMenu.addEventListener('click', ()=>{
        phoneMenu.classList.remove('phoneMenuShow')
    })
}
let abierto = false;

const toggleMenu = () =>{
    enlaces.classList.toggle("enlaces2");
    enlaces.style.transition = "transform 0.5s ease-in-out";
};

hamburguesa.addEventListener("click", function(){
    toggleMenu();
    if(document.querySelector(".enlaces.enlaces2")){
        abierto=true;
    }else{
        abierto=false;
    }
});
window.addEventListener("click", function(e){
    //this.console.log(e.target)
    if(abierto){
        if(e.target !== menuHamburguesa){
            toggleMenu();
            abierto=false;
        }
    }
});

window.addEventListener("resize", function(){
    if(this.screen.width > 1024){
        if (abierto) {
            toggleMenu();
            enlaces.style.transition = "none";
            abierto = false;
        }
    }
});

var instagram_count = 1;
$(window).scroll(function() {
    if(elementVisible( $('.instagramImages') )){
        if(instagram_count == 1){
            instagram_count = 2;
            getInstagram();
        }
    }
});

function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}

function getInstagram() {
    //return false;
    var token_instagram = 'IGQVJWa0lJWTBZAU2JmUXNzeHBIb2J6d1lhMHNpR2x3NWxXZA3lrRDUtbld3eW45RUtmUXJnVWNCSjBQdWVweGstdXhpTl9XWTNoYm5KNF85ck9KOEtrWW1ncHRMSjRlU3haUjZAVRlhOZA3BqQXF2cnBqeAZDZD';
    var URL_API_INSTAGRAM = "https://graph.instagram.com/me?fields=username,media&access_token="+token_instagram;
    $.getJSON(URL_API_INSTAGRAM, function (data) {
        var i = 0;
        var url_instagram = '';
        $('.instagramImages').html("");
        $.each(data.media.data, function (item, value) {
            if (i <= 7) {
                var MediaInstagram = "https://graph.instagram.com/"+value.id+"?fields=caption,media_url,media_type,id,permalink,thumbnail_url&access_token="+token_instagram;
                $.getJSON(MediaInstagram, function (data_media) {
                    if(data_media.media_type == 'VIDEO'){
                        url_instagram = data_media.thumbnail_url;
                    }else{
                        url_instagram = data_media.media_url;
                    }
                    $('.instagramImages').append('' +
                        '\n' +
                        '            <div class="cont-inst">\n' +
                        '                <a target="_blank" href="'+data_media.permalink+'">\n' +
                        '                    <div class="containerInstagram">\n' +
                        '                        <div class="img">\n' +
                        '                            <img src="'+url_instagram+'" alt="">\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </a>\n' +
                        '            </div>');
                });
            }
            i++;
        });
    });
}

/*
IGQVJYY0pBUmpjMWpzNWY0YWJSUEo1MmVVLUpTUGdPS3JUa1F0M3ZAPM0VYOU43QkJ1ZAkVISmx0SU9QUUJ5TnhzT0dRQjlIOGduczBaelJ6a3VldEtEckhkY3QzS0RMdTQ4UXFEcWpGZAUN4eDBWVjctUwZDZD
var URL_API_INSTAGRAM = "https://v1.nocodeapi.com/gutand/instagram/YexjwlcdcozguZQS";
$.getJSON(URL_API_INSTAGRAM,function(data) {
    var i = 0;
    var url_instagram = '';
    $('.instagramImages').html("");
    $.each(data.data, function (item, value) {
        if (i <= 7) {
            if(data.data[i].media_type == 'VIDEO'){
                url_instagram = data.data[i].thumbnail_url;
            }else{
                url_instagram = data.data[i].media_url;
            }
            $('.instagramImages').append('' +
                '\n' +
                '            <div class="cont-inst">\n' +
                '                <a target="_blank" href="'+data.data[i].permalink+'">\n' +
                '                    <div class="containerInstagram">\n' +
                '                        <div class="img">\n' +
                '                            <img src="'+url_instagram+'" alt="">\n' +
                '                        </div>\n' +
                '                    </div>\n' +
                '                </a>\n' +
                '            </div>');
        }
        i++;
    });
});
 */

//reveal elements
//ScrollReveal().reveal('.carro',{ interval: 200 });

/*
const input = document.getElementById("input");
const output = document.getElementById("output");

input.addEventListener("input", () => {
  output.textContent = input.value;
});
*/